module.exports = "./img/30a93b2038622579e150f71e4366b7de.jpg";